import React from 'react';
import { useSelector } from 'react-redux';
import { FormattedMessage } from 'react-intl';

import usePreAuthorizedAmounts from 'hooks/usePreAuthorizedAmounts';

import { arePreApprovedPricesHidden } from 'modules/selfServices/selectors';

import PreAuthorizedAmountLine from 'components/RepairOrder/PreAuthorizedAmountLine';
import List, { ListProps } from './List';

const RepairOrderList: React.FC<Pick<ListProps, 'items'>> = ({ items }) => {
  const hidePreApprovedWorksPrices = useSelector(arePreApprovedPricesHidden);

  const { customerPreAuthorizedAmount, hasCustomerPreAuthorizedAmount } = usePreAuthorizedAmounts();
  const hideTotals = hasCustomerPreAuthorizedAmount && hidePreApprovedWorksPrices;

  return (
    <>
      <List
        items={items}
        showHiddenPriceWarning
        hideTotals={hideTotals}
        title={<FormattedMessage id="basket.total.workOrder" defaultMessage="Planned works" />}
      />
      {hasCustomerPreAuthorizedAmount && (
        <PreAuthorizedAmountLine
          amount={customerPreAuthorizedAmount}
          className="flex justify-between items-center text-lowest [&>span]:text-xs font-medium pl-2"
        />
      )}
    </>
  );
};

export default RepairOrderList;
